import dayjs from 'dayjs';

import customerParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(customerParseFormat);

const utcDayjs = (...args: any[]) => {
  if (dayjs().isUTC()) {
    return dayjs(...args).utc();
  }

  return dayjs(...args);
};

utcDayjs.duration = dayjs.duration;

export default utcDayjs;
